import { render } from "./parade.vue?vue&type=template&id=438a9f3d"
import script from "./parade.vue?vue&type=script&lang=js"
export * from "./parade.vue?vue&type=script&lang=js"

import "./parade.vue?vue&type=style&index=0&id=438a9f3d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__